import { CheckIcon } from "@primer/octicons-react";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import type * as React from "react";
import { cn } from "@/lib/utils";

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "grid size-4 shrink-0 place-items-center rounded-[4px] border border-input bg-background text-on-emphasis disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-ring data-[state=checked]:bg-ring",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator>
        <CheckIcon size={12} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

/** A checkbox with a bold title and a muted description, the whole block clickable. */
function CheckboxField({ title, description, nested, className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root> & { title: React.ReactNode; description?: React.ReactNode; nested?: boolean }) {
  return (
    <label data-slot="checkbox-field" className={cn("flex cursor-pointer items-start gap-2 [[data-slot=checkbox-field]+&]:mt-3", nested && "ml-6", className)}>
      <Checkbox className="mt-[3px]" {...props} />
      <span className="flex min-w-0 flex-col gap-0.5">
        <b>{title}</b>
        {description && <span className="text-xs text-muted-foreground">{description}</span>}
      </span>
    </label>
  );
}

export { Checkbox, CheckboxField };
